import {cr} from 'fire-wind-water';

export function updateDirty(list) {
  let isVerify = true;
  let field = [];
  let verificationCode = false;
  let scenesKey = '';
  cr.each(list, d => {
    const v = {
      fieldName: d.fieldName,
      value: d.value
    };
    if (d.fieldType === 'LIST') {
      v.otherValue = d.otherValue;
    }

    field.push(v);

    d.dirty = true;
    d.sensitivDirty = true;
    if (d.isSendSms == 1) {
      d.verificationCodeDirty = true;
      verificationCode = d.verificationCode;
      scenesKey = d.scenesKey;
    }
    if (d.fieldType === 'LIST' && d.listOptionType === 'CUSTOM') {
      cr.each(d.listOptions, m => {
        m.dirty = true;
      });
    }
    if (d.invalid) {
      isVerify = false;
    }
  });
  return {
    isVerify: isVerify,
    field: field,
    verificationCode: verificationCode,
    scenesKey: scenesKey
  };
}